import { TierPointsProgressBar } from "../../../TierPointsProgressBar";
import { useCartOverviewTierContext } from "../../context";
import { BenefitsList } from "../BenefitsList";

import styles from "../../CartOverviewTier.module.scss";

export const CartOverviewTierProgress = () => {
  const {
    isLoading,
    currentPoints,
    tier,
    pointsForGoldTier,
    pointsForBlackTier,
    tiersNames,
    showBenefits,
    benefits,
    benefitsTitle,
  } = useCartOverviewTierContext();
  const hasBenefits = showBenefits && !!benefits?.length;

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.statusWrapper}>
      <TierPointsProgressBar
        currentPoints={currentPoints}
        tier={tier}
        pointsForGoldTier={pointsForGoldTier}
        pointsForBlackTier={pointsForBlackTier}
        tiersNames={tiersNames}
      />
      {hasBenefits && <BenefitsList benefits={benefits} title={benefitsTitle} />}
    </div>
  );
};
